<template>
  <div class="position-relative">
    <b-row align-v="center" no-gutters id="subheader">
      <b-col cols="auto" class="p-0 flex gap-x-2">
        <!-- Logo -->
        <a href="https://www.workinaustria.com" target="_blank">
          <div class="p-0 bg-aba-primary h-100">
            <img :src="require('@/assets/img/logo-ABA-work.svg')" alt="ABA" class="img img-fluid logo-header" />
          </div>
        </a>
        <!-- /Logo -->

      </b-col>
      <b-col cols="auto" class="position-static">
        <!-- Logo -->
        <a href="https://www.come2upperaustria.com/" target="_blank">
          <div class="p-0 h-100 px-2">
            <img :src="require('@/assets/img/logo/logo-abaooe.png')" style="max-width: 154px" alt="ABA" class="img img-fluid logo-header" />
          </div>
        </a>
        <!-- /Logo -->
      </b-col>
      <b-col cols="auto" class="d-none d-md-flex ml-auto">
        <a
          :href="immigrationGuideLink"
          target="_blank"
          rel="noopener"
          class="btn btn-tertiary header-btn-get-in-touch btn-sm d-none d-lg-block m-0 ml-half"
        >
          Immigration Guide
        </a>
      </b-col>
      <b-col cols="auto" class="d-flex ml-auto ml-md-0 mr-3 mr-md-3">
        <language-header />
      </b-col>
    </b-row>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import LanguageHeader from '@/components/Header/LanguageHeader.vue';
import { AppModule } from '@/store/modules/app';

interface GeneralLink {
  text: string
  link_en?: string
  link_de: string
  link?: () => string
}

@Component({
  components: {
    LanguageHeader,
  },
})
export default class InformationNavigation extends Vue {
  get translations() {
    return AppModule.translation;
  }

  get lang() {
    return AppModule.language;
  }

  get generalLinks() {
    const resultArr: GeneralLink[] = [
      {
        text: this.translations[13996],
        link_de: 'https://www.workinaustria.com/warum-oesterreich',
        link_en: 'https://www.workinaustria.com/en/why-austria',
      },
      {
        text: this.translations[13997],
        link_de: 'https://www.workinaustria.com/aufenthalt-beschaeftigung',
        link_en: 'https://www.workinaustria.com/en/residence-employment',
      },
      {
        text: this.translations[13998],
        link_de: 'https://www.workinaustria.com/leben-arbeiten',
        link_en: 'https://www.workinaustria.com/en/living-working',
      },
      {
        text: this.translations[13999],
        link_de: 'https://www.workinaustria.com/unsere-services',
        link_en: 'https://www.workinaustria.com/en/our-services',
      },
    ];

    return resultArr.map(({ ...rest }) => ({
      link: () => (rest[`link_${this.lang}` as keyof GeneralLink] as string) || rest.link_de,
      ...rest,
    }));
  }

  get immigrationGuideLink() {
    return `https://immigration-guide.workinaustria.com/${this.lang === 'en' ? '' : '/de/'}`;
  }
}
</script>
<style scoped lang="scss">
.main-nav-list {
  background: #f6f9fb;
  padding: 0 0 0 3rem;
  margin: 0;
}

.main-nav-link-wrapper {
  >a, >a:visited, >a:active, >a:hover {
    color: rgb(var(--aba-secondary-600));
    text-decoration: none;
  }
}
</style>
